import React, { useCallback, useContext, useEffect, useRef, useState } from 'react'
import { RoleRoutes } from 'router'
import { Header, Snackbar, SideBar } from 'components'
import { WrapContent, Wrap } from './Style'
import { WrapScreen } from 'styles/GlobalStyle'
import { useSelector } from 'react-redux'
import { audioTranscriptionRQ, application, testTakerRQ } from 'store/hooks'
import { isEqual, isNaN, isNumber } from 'lodash'
import { useDispatch } from 'react-redux'
import { actions } from 'store'
import { ErrorBoundary } from 'react-error-boundary';
import { AbilityContext } from 'components/Permissions/Can'
import { useLocation } from 'react-router-dom'
import { secretStorage } from 'config'
import { WrapAlert as Alerts } from 'components/Alerts'
import { hideElementsInFeatures } from 'keys/elements'
import { getTestTakerFetch } from 'store/middlewares/testTakers.crud'
import { AppData } from '.'
import { headerHooks } from 'components/Header'
import { ErrorFallback } from 'pages'
import { performAssessmentHooks } from 'pages/School/PerformAssessment'

const Main = () => {
    const { roleIndex } = useSelector(state => state.user)

    const { user_data, default_user_roles } = secretStorage.getItem("user")

    const ability = useContext(AbilityContext)
    const location = useLocation();
    const pathSegments = location.pathname.split('/').filter(Boolean);

    const { testTaker } = useSelector(state => state.testTaker)
    const { defaultRole } = useSelector(state => state.user)

    const setAppData = application.useInitAppData()
    const cleanAppData = application.useCleanAppData()
    const setRoleIndex = application.useRoleIndex()
    const headerHeight = headerHooks.useHeaderHeight()

    // מיועד לעלות את כל הקבצים שנתקעו בזמן העלאה
    performAssessmentHooks.useSyncPendingUploads()

    const previousTestTaker = useRef(testTaker)
    const dispatch = useDispatch()

    // const { } = audioTranscriptionRQ.useGetInit()

    const getTestTakerOnChange = async () => {
        if (testTaker?.test_taker_id && !isEqual(testTaker, previousTestTaker.current)) {
            const { data } = await getTestTakerFetch(testTaker.test_taker_id)
            previousTestTaker.current = data
            dispatch(actions.setTestTaker(data))
        }
    }

    useEffect(() => {
        setAppData()
        const token = secretStorage.getItem("user")?.token
        if (token)
            dispatch(actions.setToken(token))
    }, [roleIndex])

    useEffect(() => {

        if (user_data.length == 1) {
            const selectedUserRole = user_data[0]
            dispatch(actions.setDefaultRole(selectedUserRole))
            setRoleIndex(0)

            return
        }
        else {
            if (default_user_roles && user_data.length > 1) {
                const selectedUserRole = user_data.find((data) => data.user_roles == default_user_roles)
                dispatch(actions.setDefaultRole(selectedUserRole))
            }

            const selectedUserRoleIndex = user_data.findIndex((data) => data.user_roles == default_user_roles)
            if (selectedUserRoleIndex != -1) { }
            setRoleIndex(selectedUserRoleIndex)
        }
    }, [])

    useEffect(() => {
        getTestTakerOnChange()
    }, [testTaker])

    useEffect(() => {
        return (() => {
            cleanAppData()
        })
    }, [])

    let featureName = pathSegments.length > 0 ? pathSegments[0] : null;
    if (pathSegments[1]) {
        if (!isNaN(Number(pathSegments[1])))
            featureName += '/:id'
        else featureName += `/${pathSegments[1]}`
    }
    if (pathSegments[2]) {
        const pathSegments2 = Number(pathSegments[2])
        if (isNumber(pathSegments2) && !isNaN(pathSegments2)) {
            featureName += '/:id'
        }
        else featureName += `/${pathSegments[2]}`
    }

    const hideSidebar = hideElementsInFeatures?.[featureName]?.sideBar || false
    const hideToolbar = hideElementsInFeatures?.[featureName]?.header || false
    const hidePulldowns = hideElementsInFeatures?.[featureName]?.pulldowns || false
    const hidePadding = hideElementsInFeatures?.[featureName]?.padding || false

    const showSidebar = ability.can("read", "sidebar") && !hideSidebar
    const showToolbar = ability.can("read", "toolbar") && !hideToolbar
    const showPulldowns = ability.can("read", "showPulldowns") && !hidePulldowns

    return (
        <WrapScreen>
            <AppData />
            <Alerts />
            <Snackbar />
            {showSidebar && <SideBar />}
            {showToolbar && defaultRole && <Header hide={!showPulldowns} />}
            <Wrap headerHeight={headerHeight} showSidebar={showSidebar} showToolbar={showToolbar}>
                <WrapContent headerHeight={headerHeight} hidePadding={hidePadding} showSidebar={showSidebar} showToolbar={showToolbar}>
                    <ErrorBoundary
                        FallbackComponent={ErrorFallback}
                        onReset={() => {
                            window.location.reload();
                        }}
                    >
                        <RoleRoutes />
                    </ErrorBoundary>
                </WrapContent>
            </Wrap>
        </WrapScreen>
    )
}

export default Main


